<template>
  <b-row>
    <b-col cols="12">
      <b-modal
        :visible="true"
        size="xl"
        :title="editData ? 'Modificar subtítulo' : 'Añadir subtítulo'"
        :ok-title="editData ? 'Modificar subtítulo' : 'Añadir subtítulo'"
        cancel-title="Cancelar"
        id="hover-modal"
        @ok="addSubtitleModalBtn"
        @hidden="modalHidden"
      >
        <b-row>
          <b-col :cols="12">
            <b-row>
              <b-form-group label="Subtítulo" class="col-12">
                <b-form-input type="text" v-model="subtitle"></b-form-input>
              </b-form-group>
            </b-row>
          </b-col>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'SubtitleModal',
  props: ['productID', 'editData', 'show'],

  components: {},
  data() {
    return {
      subtitle: '',
    };
  },
  created() {},
  methods: {
    modalHidden() {
      this.$emit('hidden');
    },
    addSubtitleModalBtn(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (this.editData) {
        this.$emit('editSubtitle', this.subtitle);
      } else {
        this.$emit('addSubtitle', this.subtitle);
      }

      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing');
      });
    },
  },
  computed: {},
  mounted() {
    if (this.editData) {
      // editing

      this.price = this.editData.price;
      this.quantity = this.editData.quantity;
      this.subtitle = this.editData.subtitle;
      this.productData.reference = this.editData.reference;
      this.productData.description = this.editData.description;

      this.evaluateUpdatePrice();
    }
  },
  updated() {
    //this.renderViews();
  },
};
</script>

<style scoped>
.canvas {
  width: 100%;
  height: 40em;
  /*background: #ebebeb;*/
}
</style>
